import React from 'react';
import Footer from '../components/Footer';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-800 text-white py-20 px-4 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-20 h-20 border-2 border-white rounded-full"></div>
          <div className="absolute top-32 right-20 w-16 h-16 border-2 border-white rounded-full"></div>
          <div className="absolute bottom-20 left-1/4 w-12 h-12 border-2 border-white rounded-full"></div>
          <div className="absolute bottom-32 right-1/3 w-24 h-24 border-2 border-white rounded-full"></div>
      </div>

        <div className="relative max-w-6xl mx-auto text-center">
          <div className="mb-8">
            <div className="inline-block bg-white bg-opacity-25 backdrop-blur-sm px-6 py-3 rounded-full mb-6 border border-white border-opacity-30">
              <span className="text-sm font-medium text-white">📞 Get In Touch</span>
                  </div>
                </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-8 leading-tight text-white">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-pink-400">Contact Us</span>
          </h1>
          <p className="text-xl md:text-2xl text-white max-w-4xl mx-auto leading-relaxed font-light">
            Get in touch with us - we're here to help
          </p>
          <div className="mt-12 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 rounded-full"></div>
                  </div>
                </div>
      </section>

      {/* Campus Information Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Our Locations
                  </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Our Campuses</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Visit us at any of our three convenient locations
            </p>
                </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                name: 'Par Hoti Campus',
                badge: 'Main Campus',
                badgeColor: 'bg-blue-600',
                address: 'Nehr Chowk, Swabi Road Mardan',
                phone: '0343-0001144/55/66/77',
                programs: 'All Grades Available',
                hours: ['Monday - Friday: 8:00 AM - 3:00 PM', 'Saturday: 8:00 AM - 12:00 PM'],
                icon: '🏫',
                color: 'from-blue-500 to-blue-600',
                isMain: true
              },
              {
                name: 'DHA Campus',
                badge: '27 Years',
                badgeColor: 'bg-green-600',
                address: 'Muqam Chowk',
                phone: '0343-0001133',
                programs: 'Play Group to Grade 5',
                hours: ['Monday - Friday: 8:00 AM - 3:00 PM', 'Saturday: 8:00 AM - 12:00 PM'],
                icon: '🌟',
                color: 'from-green-500 to-green-600',
                isMain: false
              },
              {
                name: 'SMT Campus',
                badge: 'Modern',
                badgeColor: 'bg-purple-600',
                address: 'Phase-2 Sector N, House No.1',
                phone: '0343-0001122',
                programs: 'All Grades Available',
                hours: ['Monday - Friday: 8:00 AM - 3:00 PM', 'Saturday: 8:00 AM - 12:00 PM'],
                icon: '✨',
                color: 'from-purple-500 to-purple-600',
                isMain: false
              }
            ].map((campus, index) => (
              <div key={index} className={`group ${campus.isMain ? 'lg:col-span-1' : ''}`}>
                <div className={`bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 ${campus.isMain ? 'ring-2 ring-blue-200' : ''}`}>
                  <div className="flex items-center justify-between mb-6">
                    <div className={`w-16 h-16 bg-gradient-to-br ${campus.color} rounded-2xl flex items-center justify-center text-2xl`}>
                      {campus.icon}
                  </div>
                    <span className={`${campus.badgeColor} text-white px-4 py-2 rounded-full text-sm font-medium`}>
                      {campus.badge}
                    </span>
                </div>
                  
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">{campus.name}</h3>
                  
                  <div className="space-y-4">
                    <div className="flex items-start space-x-4">
                      <span className="text-gray-400 mt-1 text-lg">📍</span>
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Address</p>
                        <p className="text-sm text-gray-600">{campus.address}</p>
              </div>
            </div>
            
                    <div className="flex items-start space-x-4">
                      <span className="text-gray-400 mt-1 text-lg">📞</span>
                  <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Phone</p>
                        <p className="text-sm text-gray-600">{campus.phone}</p>
                  </div>
                </div>
                    
                    <div className="flex items-start space-x-4">
                      <span className="text-gray-400 mt-1 text-lg">🎓</span>
                  <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Programs</p>
                        <p className="text-sm text-gray-600">{campus.programs}</p>
              </div>
            </div>
            
                    <div className="flex items-start space-x-4">
                      <span className="text-gray-400 mt-1 text-lg">⏰</span>
                  <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Hours</p>
                        {campus.hours.map((hour, hourIndex) => (
                          <p key={hourIndex} className="text-sm text-gray-600">{hour}</p>
                        ))}
                  </div>
                </div>
              </div>
            </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Methods Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-green-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Contact Methods
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Get In Touch</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Have questions about our programs, admission process, or anything else? 
              We'd love to hear from you. Contact us through any of these methods.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { 
                icon: '📧', 
                title: 'Email Us', 
                info: 'info@pakschoolandcollege.com',
                description: 'Send us an email and we\'ll get back to you within 24 hours',
                color: 'from-blue-500 to-blue-600',
                action: 'mailto:info@pakschoolandcollege.com'
              },
              { 
                icon: '📱', 
                title: 'Call Us', 
                info: '0343-0001144/55/66/77',
                description: 'Speak directly with our admission team during business hours',
                color: 'from-green-500 to-green-600',
                action: 'tel:03430001144'
              },
              { 
                icon: '🌐', 
                title: 'Follow Us', 
                info: 'Social Media',
                description: 'Stay updated with our latest news and events',
                color: 'from-purple-500 to-purple-600',
                action: null
              }
            ].map((method, index) => (
              <div key={index} className="group">
                <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                  <div className={`w-16 h-16 bg-gradient-to-br ${method.color} rounded-2xl flex items-center justify-center text-2xl mb-6 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                    {method.icon}
                </div>
                
                  <div className="text-center mb-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{method.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{method.description}</p>
                </div>
                
                  {method.action ? (
                    <a 
                      href={method.action}
                      className={`w-full bg-gradient-to-r ${method.color} text-white py-3 px-6 rounded-lg font-semibold hover:opacity-90 transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center justify-center space-x-2`}
                    >
                      <span>{method.icon}</span>
                      <span>{method.info}</span>
                    </a>
                  ) : (
                    <div className="space-y-3">
                      <p className="text-center font-semibold text-gray-800">{method.info}</p>
                      <div className="flex justify-center space-x-4">
                      <a 
                        href="https://www.facebook.com/pakschoolssystem" 
                        target="_blank" 
                        rel="noopener noreferrer"
                          className="w-12 h-12 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 hover:shadow-lg"
                        aria-label="Facebook"
                      >
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                          </svg>
                      </a>
                      <a 
                        href="https://www.instagram.com/pakschoolcollege_mardan?igsh=bmw2ZXJsbmJjNnZ4" 
                        target="_blank" 
                        rel="noopener noreferrer"
                          className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 hover:shadow-lg"
                        aria-label="Instagram"
                      >
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                          </svg>
                      </a>
                    </div>
                  </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contact;
